const DELIVERY_TYPE_PICKUP = 3;
const DELIVERY_TYPE_DELIVERY = 2;
const PAYMENT_TYPE_CASH = '2';
export default class DeliveryOrder {
    constructor(data) {

        this.fieldPhone = $('input[name="phone"]');
        this.fieldComment = $('textarea[name="comment"]');
        this.fieldPersonsCount = $('input[name="number"]');
        this.fieldChange = $('#change');
        this.fieldPersonName = $('input[name="name"]');
        this.fieldEmail = $('input[name="email"]');
        this.fieldRoistat = $('input[name=ROISTAT_ID]');
        this.entityPayment = $('#payment_type');
        this.form = $('#order_form');
        this.orderDeliveries = this.prepareAddressData(data);
        this.buttonSendOrder = $('[data-action="send-order"]');
        this.buttonNext = $('[data-action="next"]');
        this.panelStepOne = $('[data-order-step="1"]');
        this.panelStepTwo = $('[data-order-step="2"]');
        this.buttonNext.on('click', this.showNextStep.bind(this));
        this.buttonSendOrder.on('click', this.doSendOrder.bind(this));
        this.culteryQuantityInput = $(document).find('input[name=cutlery-text]');
        this.culteryForksInput = $(document).find('input[name=cutlery-forks]');
        this.culterySpoonsInput = $(document).find('input[name=cutlery-spoons]');
        this.culteryKnivesInput = $(document).find('input[name=cutlery-knives]');

    }

    showNextStep() {
        this.panelStepOne.fadeOut(400, () => {
            this.panelStepTwo.fadeIn(400, () => {
                this.buttonNext.fadeOut(200, () => {
                    this.buttonSendOrder.removeClass('hide-for-small-only');
                })
            });
        });
    }

    doSendOrder(e) {
        e.preventDefault();
        e.stopPropagation();

        let change = this.entityPayment.find('span').attr('pay_id') !== PAYMENT_TYPE_CASH ? '-' : this.fieldChange.text();
        let order = {
            'ORDER_DELIVERIES': this.orderDeliveries,
            'COL_PERSONS': this.fieldPersonsCount.val(),
            'CHANGE': change,
            'COMMENT': this.fieldComment.val(),
            'MAIL': this.fieldEmail.val(),
            'PHONE': this.fieldPhone.val(),
            'NAME': this.fieldPersonName.val(),
            'ROISTAT_ID': this.fieldRoistat.val(),
            'payment_type': this.entityPayment.text(),
            'payment_id': this.entityPayment.find('span').attr('pay_id'),
            'ADDRESS': {
                'value': this.orderDeliveries[0]['value'],
                'delivery_id': this.orderDeliveries[0]['delivery_id'],
                'terminal_guid': this.orderDeliveries[0]['terminal_guid'],
            },
            'NUMBER_OF_CUTLERY': this.culteryQuantityInput ? this.culteryQuantityInput.val() : 0,
            'NUMBER_OF_CUTLERY_FORKS': this.culteryForksInput ? this.culteryForksInput.val() : 0,
            'NUMBER_OF_CUTLERY_SPOONS': this.culterySpoonsInput ? this.culterySpoonsInput.val() : 0,
            'NUMBER_OF_CUTLERY_KNIVES': this.culteryKnivesInput ? this.culteryKnivesInput.val() : 0,

        };


        $('#loader-result').show();

        $.ajax({
            type: this.form.attr("method"),
            url: this.form.attr("action"),
            data: order,
            dataType: "json",
            success: function (data) {
                if (data.data.status == "error") {
                    // заказ запрещен
                    location.replace("/personal/cart/#orderStartModalOrder");
                } else {
                    location.replace('/personal/order-result/?ORDER_ID=' + data.data[0].orderId);
                }
            },
        });

    }

    prepareAddressData(data) {
        let result = [];
        if (data.order) {
            Object.entries(data.order).forEach(([date, address]) => {
                let dayRes = address;
                dayRes['delivery_id'] = address.self_pickup == '1' ? DELIVERY_TYPE_PICKUP : DELIVERY_TYPE_DELIVERY;
                dayRes['value'] = this.createAddressString(address);
                dayRes['flat'] = address['flat'];
                dayRes['floor'] = address['floor'];
                dayRes['entry'] = address['entry'];
                dayRes['housing'] = address['housing'];
                dayRes['address_comment'] = address['comment'];

                result.push(dayRes);
            });
        }
        return result;
    }

    createAddressString(address) {
        let result = address['street'];
        if (address['house']) {
            result = result + ', д. ' + address['house'];
        }
        if (address['housing']) {
            result = result + ', к. ' + address['housing'];
        }
        return result;
    }

}
